export const convertToArray = (value) =>
  Array.isArray(value) ? value : [value];

const basePredicat = (value) => value != null && value !== '';

export const compactArray = (value, predicat = basePredicat) =>
  value.filter(predicat);

export const asIs = (value) => value;
